import Header from './components/Header';
import AnchorScroll from './components/AnchorScroll'
import ProgressBar from './components/ProgressBar'
import SectionAnimationMobile from './components/SectionAnimationMobile'

export default () => {
  const header = new Header();
  header.bindEvents()

  const anchorScroll = new AnchorScroll();
  anchorScroll.bindEvents()

  const progressbar = new ProgressBar();
  progressbar.bindEvents()

  const sectionAnimationMobile = new SectionAnimationMobile();
  sectionAnimationMobile.bindEvents()
}
